export default __webpack_public_path__ + "static/media/Icon ionic-ios-time.a218ca18.svg";